export const CARS_NAV = [
  {
    "title": "Asuransi Mobil",
    "link": "#",
    "childItems": [
      {
        "title": "Asuransi Mobil Terbaik",
        "link": "/produk/asuransi-mobil/",
      },
      {
        "title": "Asuransi Mobil All Risk",
        "link": "/produk/asuransi-mobil/all-risk/",
      },
      {
        "title": "Asuransi Mobil TLO",
        "link": "/produk/asuransi-mobil/tlo/",
      },
      {
        "title": "Asuransi Mobil Syariah",
        "link": "/produk/asuransi-mobil/syariah/",
      },
      {
        "title": "Asuransi Mobil Bekas",
        "link": "/produk/asuransi-mobil/bekas/",
      },
      {
        "title": "Asuransi Mobil Pihak Ketiga",
        "link": "/produk/asuransi-mobil/pihak-ketiga/",
      },
      {
        "title": "Asuransi Mobil Listrik",
        "link": "/produk/asuransi-mobil/listrik/",
      }
    ]
  },
];